import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.quiz');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";
import { TTS } from "src/libs/portal/korslovo/tts";
import { gradeAnswer, GradeResult } from "src/libs/portal/korslovo/grading";

@Component({
    selector: 'wiz-page-korslovo-quiz',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.quiz/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@keyframes bounceIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate-bounce-in {
  animation: bounceIn 0.6s ease-out;
}

/* XP Badge */
.xp-earned-badge {
  animation: xpBadgeIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes xpBadgeIn {
  0% {
    transform: scale(0) rotate(-20deg);
    opacity: 0;
  }
  60% {
    transform: scale(1.15) rotate(5deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
/* Level Up Modal */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes cardSlideUp {
  0% {
    transform: translateY(40px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
@keyframes levelUpStar {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.15) rotate(-10deg);
  }
  50% {
    transform: scale(1.25) rotate(0deg);
  }
  75% {
    transform: scale(1.15) rotate(10deg);
  }
}`],
})
export class PageKorslovoQuizComponent implements OnInit, OnDestroy {
    public ru = RU;
    public loading: boolean = true;
    public lessonId: string = '';
    public quizType: string = 'choice';
    public questions: any[] = [];
    public currentIndex: number = 0;
    public selectedAnswer: any = null;
    public answered: boolean = false;
    public isCorrect: boolean = false;
    public isPartial: boolean = false;
    public isAccepted: boolean = false;
    public gradeResult: GradeResult | null = null;
    public answers: any[] = [];
    public finished: boolean = false;
    public result: any = {};
    public speaking: boolean = false;
    public sttResult: string = '';

    // XP animation state
    public xpResult: any = null;
    public showXpAnimation: boolean = false;
    public showLevelUp: boolean = false;
    public xpAnimValue: number = 0;

    private tts: TTS = new TTS();
    private recognition: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.lessonId = WizRoute.segment.id;
        this.quizType = WizRoute.segment.type || 'choice';
        if (!this.lessonId) {
            this.service.href('/category');
            return;
        }
        await this.loadQuiz();
    }

    ngOnDestroy() {
        this.tts.stop();
        if (this.recognition) {
            try { this.recognition.abort(); } catch (e) {}
        }
    }

    public async loadQuiz() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("generate", {
            lesson_id: this.lessonId,
            quiz_type: this.quizType
        });
        if (code === 200) {
            this.questions = data || [];
        }

        this.loading = false;
        this.currentIndex = 0;
        this.answers = [];
        this.finished = false;

        if (this.quizType === 'listening' && this.questions.length > 0) {
            setTimeout(() => this.speakCurrent(), 500);
        }

        await this.service.render();
    }

    public get currentQuestion(): any {
        return this.questions[this.currentIndex] || {};
    }

    public get progressPercent(): number {
        if (this.questions.length === 0) return 0;
        return Math.round(((this.currentIndex + 1) / this.questions.length) * 100);
    }

    // === Choice / Listening ===

    public async selectChoice(choice: any) {
        if (this.answered) return;
        this.selectedAnswer = choice;
        this.answered = true;
        this.isAccepted = false;
        this.gradeResult = null;

        const q = this.currentQuestion;
        const accepted = q.accepted_list || [];

        if (this.quizType === 'choice') {
            // 선택형: 선택한 text가 정답/허용/오답인지 판단
            const result = gradeAnswer(choice.text, q.russian, accepted);
            this.gradeResult = result;
            this.isCorrect = result.grade !== 'wrong';
            this.isAccepted = result.grade === 'accepted';
        } else {
            // 듣기: 한국어 선택이므로 정확 매치만
            this.isCorrect = choice.correct;
        }

        this.answers.push({
            word_id: q.word_id,
            is_correct: this.isCorrect,
            user_answer: choice.text,
            grade: this.gradeResult?.grade || (this.isCorrect ? 'exact' : 'wrong')
        });

        await this.service.render();
    }

    // === Speaking ===

    public async startSpeaking() {
        const w = window as any;
        const SpeechRecognition = w.SpeechRecognition || w.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(this.ru.learn_mic_unsupported);
            return;
        }

        this.speaking = true;
        this.sttResult = '';
        await this.service.render();

        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'ko-KR';
        this.recognition.interimResults = false;
        this.recognition.maxAlternatives = 5;

        this.recognition.onresult = async (event: any) => {
            const results = event.results[0];
            const target = this.currentQuestion.korean;
            let bestTranscript = results[0]?.transcript || '';
            let bestMatch: 'exact' | 'partial' | 'none' = 'none';

            for (let i = 0; i < results.length; i++) {
                const transcript = results[i].transcript;
                const match = this.compareSpeech(transcript, target);
                if (match === 'exact') {
                    bestMatch = 'exact';
                    bestTranscript = transcript;
                    break;
                }
                if (match === 'partial' && bestMatch !== 'exact') {
                    bestMatch = 'partial';
                    bestTranscript = transcript;
                }
            }

            this.sttResult = bestTranscript;
            this.answered = true;
            this.isCorrect = bestMatch === 'exact';
            this.isPartial = bestMatch === 'partial';

            this.answers.push({
                word_id: this.currentQuestion.word_id,
                is_correct: bestMatch === 'exact',
                user_answer: bestTranscript,
                stt_result: bestTranscript,
                grade: bestMatch === 'exact' ? 'exact' : 'wrong'
            });

            this.speaking = false;
            await this.service.render();
        };

        this.recognition.onerror = async () => {
            this.speaking = false;
            await this.service.render();
        };

        this.recognition.onend = async () => {
            this.speaking = false;
            await this.service.render();
        };

        this.recognition.start();
    }

    // === TTS ===

    public speakCurrent() {
        this.tts.speak(this.currentQuestion.korean);
    }

    // === Navigation ===

    public async nextQuestion() {
        this.selectedAnswer = null;
        this.answered = false;
        this.isCorrect = false;
        this.isPartial = false;
        this.isAccepted = false;
        this.gradeResult = null;
        this.sttResult = '';

        if (this.currentIndex < this.questions.length - 1) {
            this.currentIndex++;
            await this.service.render();

            if (this.quizType === 'listening') {
                setTimeout(() => this.speakCurrent(), 300);
            }
        } else {
            await this.submitQuiz();
        }
    }

    public async submitQuiz() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("submit", {
            lesson_id: this.lessonId,
            quiz_type: this.quizType,
            answers: JSON.stringify(this.answers)
        });
        if (code === 200) {
            this.result = data || {};
            if (data.xp) {
                this.xpResult = data.xp;
            }
        }

        this.finished = true;
        this.loading = false;
        await this.service.render();

        if (this.xpResult) {
            await this.animateXp(this.xpResult);
        }
    }

    public get resultAccuracy(): number {
        if (!this.result.total_count) return 0;
        return Math.round((this.result.correct_count / this.result.total_count) * 100);
    }

    public get resultPrecision(): number {
        if (!this.result.total_count) return 0;
        return Math.round(((this.result.exact_count || 0) / this.result.total_count) * 100);
    }

    public get wrongAnswers(): any[] {
        return this.answers.filter(a => a.grade === 'wrong').map(a => {
            const q = this.questions.find(q => q.word_id === a.word_id);
            return { ...a, korean: q?.korean || '', russian: q?.russian || '', pronunciation: q?.pronunciation || '' };
        });
    }

    public get acceptedAnswers(): any[] {
        return this.answers.filter(a => a.grade === 'accepted').map(a => {
            const q = this.questions.find(q => q.word_id === a.word_id);
            return {
                ...a,
                korean: q?.korean || '',
                russian: q?.russian || '',
                pronunciation: q?.pronunciation || '',
                accepted_hint: q?.accepted_hint || ''
            };
        });
    }

    // === Actions ===

    public retry() {
        this.xpResult = null;
        this.showXpAnimation = false;
        this.showLevelUp = false;
        this.xpAnimValue = 0;
        this.loadQuiz();
    }

    public goNextType() {
        if (this.quizType === 'choice') {
            this.service.href(`/quiz/${this.lessonId}/listening`);
        } else if (this.quizType === 'listening') {
            this.service.href(`/quiz/${this.lessonId}/speaking`);
        } else {
            this.service.href('/category');
        }
    }

    public goBack() {
        this.service.href(`/learn/${this.lessonId}`);
    }

    public goHome() {
        this.service.href('/dashboard');
    }

    private async animateXp(xp: any) {
        this.showXpAnimation = true;
        this.xpAnimValue = 0;
        await this.service.render();

        const target = xp.xp_earned || 0;
        const steps = 20;
        const delay = Math.max(30, 600 / steps);
        for (let i = 1; i <= steps; i++) {
            this.xpAnimValue = Math.round((target / steps) * i);
            await this.service.render();
            await new Promise(r => setTimeout(r, delay));
        }
        this.xpAnimValue = target;
        await this.service.render();

        if (xp.level_up) {
            await new Promise(r => setTimeout(r, 400));
            this.showLevelUp = true;
            await this.service.render();
        }
    }

    public async dismissLevelUp() {
        this.showLevelUp = false;
        await this.service.render();
    }

    private normalize(text: string): string {
        return (text || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    private normalizeKorean(text: string): string {
        let s = (text || '').trim();
        s = s.replace(/[.,!?~…·\-\(\)\[\]\{\}\"\'""'']/g, '');
        s = s.replace(/\s+/g, ' ').trim();
        return s.toLowerCase();
    }

    private stripParticles(text: string): string {
        const particles = /(?:에서|으로|한테|에게|부터|까지|은|는|이|가|을|를|에|의|도|와|과|로|만)$/;
        return text.split(' ').map(word => {
            if (word.length <= 1) return word;
            return word.replace(particles, '') || word;
        }).join(' ');
    }

    private similarity(a: string, b: string): number {
        if (a === b) return 1;
        if (!a || !b) return 0;
        const m = a.length, n = b.length;
        const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
        for (let i = 1; i <= m; i++) {
            for (let j = 1; j <= n; j++) {
                dp[i][j] = a[i - 1] === b[j - 1]
                    ? dp[i - 1][j - 1] + 1
                    : Math.max(dp[i - 1][j], dp[i][j - 1]);
            }
        }
        return (2 * dp[m][n]) / (m + n);
    }

    private compareSpeech(spoken: string, target: string): 'exact' | 'partial' | 'none' {
        const normSpoken = this.normalizeKorean(spoken);
        const normTarget = this.normalizeKorean(target);

        if (normSpoken === normTarget) return 'exact';

        const strippedSpoken = this.stripParticles(normSpoken);
        const strippedTarget = this.stripParticles(normTarget);
        if (strippedSpoken === strippedTarget) return 'exact';

        const sim = this.similarity(strippedSpoken, strippedTarget);
        if (sim >= 0.85) return 'exact';
        if (sim >= 0.5) return 'partial';
        return 'none';
    }
}

export default PageKorslovoQuizComponent;